import { UiButtonComponent } from 'src/app/shared/ui';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MaintenanceService,
  MaintenanceStatus,
  MaintenanceMode,
} from 'src/app/core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  standalone: true,
  imports: [UiButtonComponent, CommonModule],
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  maintenanceStatus: MaintenanceStatus | null = null;
  maintenanceMode: MaintenanceMode = 'none';
  private statusSubscription?: Subscription;
  private modeSubscription?: Subscription;

  constructor(private maintenanceService: MaintenanceService) {}

  ngOnInit() {
    this.statusSubscription =
      this.maintenanceService.maintenanceStatus$.subscribe(
        (status) => (this.maintenanceStatus = status)
      );

    this.modeSubscription = this.maintenanceService.maintenanceMode$.subscribe(
      (mode) => (this.maintenanceMode = mode)
    );
  }

  ngOnDestroy() {
    if (this.statusSubscription) {
      this.statusSubscription.unsubscribe();
    }
    if (this.modeSubscription) {
      this.modeSubscription.unsubscribe();
    }
  }

  onRetryClick() {
    window.location.reload();
  }

  get isServerError(): boolean {
    return this.maintenanceMode === 'server_error';
  }

  get isPlannedMaintenance(): boolean {
    return this.maintenanceMode === 'planned';
  }

  get mainTitle(): string {
    if (this.isServerError) {
      return this.maintenanceStatus?.diagnostic?.canSignIn
        ? 'Bitte erneut anmelden' : 'Das hat leider nicht geklappt';
    }
    return 'Karten werden gemischt';
  }

  get displayMessage(): string {
    if (this.isServerError) {
      return (
        this.maintenanceStatus?.message ||
        'Es treten gerade unerwartete Serverfehler auf. Wir arbeiten daran, das Problem zu beheben.'
      );
    }
    return (
      this.maintenanceStatus?.message ||
      'Das Schnapsen-Spiel wird gerade vorbereitet!'
    );
  }

  get subMessage(): string {
    if (this.isServerError) {
      return 'Bitte versuche es in wenigen Minuten erneut. Sollte das Problem bestehen bleiben, kontaktiere uns.';
    }
    return 'Wir mischen die Karten und bereiten den Spieltisch vor. In wenigen Minuten kannst du wieder spielen.';
  }

  get updatedAt(): string | null {
    if (!this.maintenanceStatus?.updated_at) return null;
    return new Date(this.maintenanceStatus.updated_at).toLocaleString('de-AT');
  }
}
